import { Component, OnInit, ElementRef, HostListener, AfterViewInit, ViewChild, ChangeDetectorRef, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { NewActivityGenericComponent } from 'src/app/shared/new-activity-generic/new-activity-generic.component';
import { WavesModule, SelectModule, MDBModalRef, MDBModalService, ToastService } from 'ng-uikit-pro-standard';
import { NewTaskModalComponent } from '../../sales-management/sales-leads/modals/new-task-modal/new-task-modal.component';
import { MdbTableDirective, MdbTablePaginationComponent } from 'ng-uikit-pro-standard';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { MapInformationService } from 'src/app/services/map-information.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SalesProjectService } from 'src/app/services/sales-project.service';
import { ProjectService } from 'src/app/services/project.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { CustomerService } from 'src/app/services/customer.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PipelineService } from 'src/app/services/pipeline.service';
import { GeneralService } from 'src/app/services/general.service';
import { DxDataGridComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { IMyOptions } from 'ng-uikit-pro-standard';
import { DatePipe, Location } from '@angular/common';
import Popup from 'devextreme/ui/popup';
import { TranslateService } from '@ngx-translate/core';
import { CreateUpdateActivityComponent } from 'src/app/pages/home/my-activity/create-update-activity/create-update-activity.component';
import CustomStore from 'devextreme/data/custom_store';

@Component({
  selector: 'activity-dinamic',
  templateUrl: './activity-dinamic.component.html',
  styleUrls: ['./activity-dinamic.component.scss']
})
export class activityDinamicComponent implements OnInit, OnChanges {
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild('row', { static: true }) row: ElementRef;
  @Input() VieneDe: any;
  // @Input() idParent: any;
  @Output() Converted = new EventEmitter();
  @ViewChild("GridTemplate", { static: false }) GridTemplate: DxDataGridComponent;
  @ViewChild("mainGrid", { static: false }) mainGrid: DxDataGridComponent;

  @ViewChild('updateActivity', { static: false }) updateActivity: CreateUpdateActivityComponent;
  @ViewChild("newRequestBySelect", { static: false }) newRequestBySelect: DxSelectBoxComponent;


  // @Input() projectid: any;
  @Input() from: any;
  @Input() idParent: any;


  optionsPerson: Array<any>;
  optionsCType: Array<any>;
  optionSregion: Array<any>;
  optionsCity: Array<any>;
  optionsState: Array<any>;
  optionsZip: Array<any>;
  customerSelect = [];
  expandAll: boolean = false
  min = 1;
  max = 100;
  elements: any = [];
  elements2: any = [];
  elements3: any = [];
  elements4: any = [];
  elements5: any = [];
  elements6: any = [];
  elements7: any = [];

  // idParent: any;
  TaskList: any;
  TaskListData: any;

  currentyear: number;
  currentMont: number;
  currectDay: number;

  now: Date = new Date();
  now_start: Date = new Date();

  modalRef: MDBModalRef;
  // modalRefAct: MDBModalRef;
  dateFormat1: any

  public myDatePickerOptions: IMyOptions = {

    // Your options
    disableDateRanges: [{ begin: { year: 2013, month: 1, day: 1 }, end: { year: 2020, month: 11, day: 20 } }], // Disable date ranges.

  };


  DateFilter2: any = new Date();
  millisecondsInDay2 = 24 * 60 * 60 * 1000;
  todayButton2: any;
  prevDateButton2: any;
  nextDateButton2: any;

  // Head tables
  headElements = [{ head: 'Customer Id', id: 'EstimateId', class: 'text-right' },
  { head: 'Customer Number', id: 'ProjectName', class: 'text-right' },
  { head: 'Customer Name', id: 'Category', class: 'text-left' },
  { head: 'Sales Person', id: 'VerticalMarket', class: 'text-left' },
  { head: 'Customer Type', id: 'Status', class: 'text-left' },
  { head: 'Sales Region', id: 'Date', class: 'text-left' },
  { head: 'City', id: 'city', class: 'text-left' },
  { head: 'State', id: 'state', class: 'text-left' },
  { head: 'Zip', id: 'zip', class: 'text-left' },
  { head: 'Office Phone', id: 'oficPhone', class: 'text-left' },
  { head: 'Office Fax', id: 'oficFax', class: 'text-left' },
  { head: 'Credit', id: 'credit', class: 'text-left' },
  { head: 'active', id: 'active', class: 'text-left' }
  ];

  tasklistHeaders = [{ head: 'Task ID', id: 'ITEMID', class: 'text-right' },
  { head: 'Task Name', id: 'ITEMNAME', class: 'text-left' },
  { head: 'Hours', id: 'DURATION', class: 'text-right' },
  { head: 'Start Date', id: 'StartDate', class: 'text-right' },
  { head: 'Due Date', id: 'DUEDATE', class: 'text-right' },
  { head: 'Finish Date', id: 'FinishDate', class: 'text-right' },
  { head: '% Completion', id: 'Completion', class: 'text-right' },
  { head: 'Responsible', id: 'Responsible', class: 'text-left' },
  { head: 'Priority', id: 'PRIORITY', class: 'text-left' },
  { head: 'Status', id: 'STATUSID', class: 'text-left' },
  { head: 'Category', id: 'Category', class: 'text-left' }
  ];

  headElements3 = [{ head: 'Project Number', id: 'EstimateId', class: 'text-right' },
  { head: 'Project Name', id: 'ProjectName', class: 'text-right' },
  { head: 'Close Date', id: 'Category', class: 'text-left' },
  { head: 'Project Amount', id: 'VerticalMarket', class: 'text-left' }

  ];

  headElements4 = [{ head: 'Activity ID', id: 'ID', class: 'text-right' },
  { head: 'Activity Name', id: 'NAME', class: 'text-left' },
  { head: 'Date', id: 'STARTTIME', class: 'text-right' },
  { head: 'Duration', id: 'DURATION', class: 'text-right' },
  { head: 'Employee', id: 'EMPLOYEENAME', class: 'text-right' },
  { head: 'Activity Type', id: 'TYPENAME', class: 'text-left' },
  { head: 'Closed', id: 'CLOSED', class: 'text-left' }

  ];
  headElements5 = [{ head: 'Date', id: 'EstimateId', class: 'text-right' },
  { head: 'Author', id: 'ProjectName', class: 'text-right' },
  { head: 'Event Type', id: 'Category', class: 'text-left' },
  { head: 'Description', id: 'VerticalMarket', class: 'text-left' }

  ];
  headElements6 = [{ head: 'Number', id: 'EstimateId', class: 'text-right' },
  { head: 'Project Name', id: 'ProjectName', class: 'text-left' },
  { head: 'Close Date', id: 'Category', class: 'text-right' },
  { head: 'Amount', id: 'VerticalMarket', class: 'text-right' }

  ];
  headElements7 = [{ head: 'Name', id: 'EstimateId', class: 'text-left' },
  { head: 'Revision', id: 'ProjectName', class: 'text-right' },
  { head: 'Created On', id: 'Category', class: 'text-right' },
  { head: 'Created By', id: 'VerticalMarket', class: 'text-right' },
  { head: 'Description', id: 'desription', class: 'text-left' },
  { head: 'File Name', id: 'dname', class: 'text-left' },
  { head: 'Notes', id: 'notes', class: 'text-left' }
  ];
  cancelButtonFilterActivity: any
  saveButtonFilterActivity: any
  PopupNewActivity: boolean = false
  public _formEntityActivity: FormGroup;
  workcompleteddate: any;
  todayButton: any;
  prevDateButton: any;
  nextDateButton: any;
  millisecondsInDay = 24 * 60 * 60 * 1000;
  optionsPeople: any[] = []
  addProdSpeButton: any
  popupActivityType: boolean = false

  followUpDate: any;
  todayButtonfollowUpDate: any;
  prevDateButtonfollowUpDate: any;
  nextDateButtonfollowUpDate: any;
  NewService: boolean = false
  sendProjectPoPup: boolean = false
  IDSalesSend: any = ""
  openImport: boolean = false
  infoTemplate: any[] = []
  ValueOriginal: any[] = []
  openNewEditTemplateModal: boolean = false
  dataCreateTemplate: any[] = []
  idActivity: any = ""
  popupDeleteActivity: boolean = false
  projectid: any;
  addToPipelineModel = {
    estclosedate: this.datePipe.transform(new Date(), 'yyyyMMdd'),
    probabilityid: 0,
    criteriaid: 0,
    id: 0,
    projectid: '0',
    customerid: 0,
    howfound: '',
    opendate: this.datePipe.transform(new Date(), 'yyyyMMdd'),
    employeeid: 0,
    closed: 0
  };
  probabilitySelect: any;
  raitingSelect: any;
  saveButtonAddToPipeline: { text: string; icon: string; elementAttr: { id: string; }; onClick: () => void; };
  cancelButtonAddToPipeline: { text: string; elementAttr: { id: string; }; onClick: () => void; };
  popupAddPipeline: boolean = false
  AddPipe: boolean = false;
  itemIndex: any = 0;

  dataForm: any;

  items: any = [

    "undo", "redo", "separator",

    {
      name: "size",
      acceptedValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"]
    },
    {
      name: "font",
      acceptedValues: ["Arial", "Courier New", "Georgia", "Impact", "Lucida Console", "Tahoma", "Times New Roman", "Verdana"]
    },

    "separator", "bold", "italic", "strike", "underline", "separator",
    "alignLeft", "alignCenter", "alignRight", "alignJustify", "increaseIndent",
    "decreaseIndent", "separator",
    "orderedList", "bulletList", "separator",

    {
      name: "header",
      acceptedValues: [false, 1, 2, 3, 4, 5]
    },

    "color", "background", "link", "clear", "codeBlock", "blockquote", "separator", "insertTable", "deleteTable",
    "insertRowAbove", "insertRowBelow", "deleteRow", "insertColumnLeft", "insertColumnRight",
    "deleteColumn", "cellProperties", "tableProperties",
  ];
  contactDataSource: any;
  PopupNewAssociatePeopple: boolean;
  cancelButtonFilter: { text: any; elementAttr: { id: string; }; onClick: () => void; };
  saveButtonFilter: { text: any; icon: string; elementAttr: { id: string; }; onClick: () => void; };
  NameContact: string;
  private _formEntityAssociatePeople: FormGroup;
  customerID: any;
  checkBoxShowActive: boolean;
  AssociatePeopple: any;
  optionsType: any;
  optionsInfluence: any;
  popupNewContact: boolean;

  itemsCommandsActions = [
    { id: 1, name: 'Send Email' },
  ]
  filterValue: any;
  actualState: any = 0;
  gridId: any = "EmployeeActivitiesGrid1";
  showEmailConfigPopup: boolean = false;

  constructor(
    public MapInformationService: MapInformationService,
    private salesLeadsService: SalesProjectService,
    public settingsCompany: CompanySettingsService,
    private appConfigService: AppConfigService,
    private pipelineService: PipelineService,
    private customerService: CustomerService,
    private GeneralService: GeneralService,
    private modalService: MDBModalService,
    private location: Location,
    private datepipe: DatePipe,
    private toast: ToastService,
    private datePipe: DatePipe,
    private router: Router,
    private translate: TranslateService,
    private projectService: ProjectService,
  ) {

    Popup.defaultOptions({
      device: { deviceType: "phone" },
      options: {
        fullScreen: true
      }
    });

    this.currentdate();
    this.dateFormat1 = this.appConfigService.dateFormat;
    this.TaskListData = [];
    this.TaskList = [];
    this.elements2.push({ EstimateId: '5438', ProjectName: 'New Task', hours: '0.00', VerticalMarket: '03/23/2020', dueDate: '03/23/2020', finiDate: '', porComple: '0.00', responsible: 'Maria Perez', priority: 'Normal', status: 'Not Started', category: 'AutoCAD' });
    this.elements2.push({ EstimateId: '5439', ProjectName: 'Task 2', hours: '0.00', VerticalMarket: '03/23/2020', dueDate: '03/23/2020', finiDate: '', porComple: '0.00', responsible: 'Pedro Martinez', priority: 'Hight', status: 'In Progress', category: 'Customer Training' });

    this.elements4.push({ EstimateId: '5438', ProjectName: 'New Activity', Category: '03/23/2020', VerticalMarket: '1:00', Status: '', commen: 'An Employee From Service Request', employee: 'Sales Visit', type: '', closed: 'No' });
    this.elements4.push({ EstimateId: '5439', ProjectName: 'Meeting', Category: '03/23/2020', VerticalMarket: '0:30', Status: '', commen: 'An Employee From Service Request', employee: 'Sales Presentation', type: '', closed: 'No' });

    this.workcompleteddate = new Date().getTime();
    this.followUpDate = new Date().getTime();

    this.DateFilter2 = new Date(this.DateFilter2.setMonth(this.DateFilter2.getMonth() - 12));
    
    this.todayButton2 = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.DateFilter2 = new Date();
      }
    };
    this.prevDateButton2 = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        this.DateFilter2 = new Date(this.DateFilter2);
        this.DateFilter2 = this.convertdate(this.DateFilter2.getTime() - this.millisecondsInDay2);
      }
    };

    this.nextDateButton2 = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.DateFilter2 = new Date(this.DateFilter2);
        this.DateFilter2 = this.convertdate(this.DateFilter2.getTime() + this.millisecondsInDay2);
      }
    };

    this.todayButtonfollowUpDate = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        let date = this.followUpDate
        this.followUpDate = new Date(date).getTime()
        this.followUpDate = new Date().getTime();
      }
    };

    this.prevDateButtonfollowUpDate = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        let date = this.followUpDate
        this.followUpDate = new Date(date).getTime()
        this.followUpDate -= this.millisecondsInDay;
      }
    };

    this.nextDateButtonfollowUpDate = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        let date = this.followUpDate
        this.followUpDate = new Date(date).getTime()
        this.followUpDate += this.millisecondsInDay;
      }
    };

    this.todayButton = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        let date = this.workcompleteddate
        this.workcompleteddate = new Date(date).getTime()
        this.workcompleteddate = new Date().getTime();
      }
    };

    this.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        let date = this.workcompleteddate
        this.workcompleteddate = new Date(date).getTime()
        this.workcompleteddate -= this.millisecondsInDay;
      }
    };

    this.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        let date = this.workcompleteddate
        this.workcompleteddate = new Date(date).getTime()
        this.workcompleteddate += this.millisecondsInDay;
      }
    };
    this.cancelButtonFilterActivity = {
      text: this.translate.instant('ModalSaleaLeadsNContact.btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.CloseNewActivity()
      },
    };

    this.saveButtonFilterActivity = {
      text: this.translate.instant('ModalSaleaLeadsNContact.btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.SaveNewActivity()
        this.saveActivities()
      },
      // disabled: !this._formEntityActivity.
    }

    this.addProdSpeButton = {
      icon: "edit",
      type: "button",
      onClick: () => {
        this.popupActivityType = true;
      },
    };


    this.saveButtonAddToPipeline = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {
        this.addToPipeline()
      }
    };
    this.cancelButtonAddToPipeline = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        this.popupAddPipeline = false
      }
    };


    this.cancelButtonFilter = {
      text: this.translate.instant('ModuleEditCustomerNAct.btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.CloseNewAssociatePeopple()
      },
    };

    this.saveButtonFilter = {
      text: this.translate.instant('ModuleEditCustomerNAct.btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.SaveNewAssociatePeople()
      },
    }


  }

  expandedNotes: { [key: number]: boolean } = {};

  getNotesDisplay(row: any): string {
    const text = this.eliminarHTML(row.NOTES || '');
    if (text.length <= 254 || this.expandedNotes[row.ID]) {
      return text;
    }
    return text.substring(0, 254) + '...';
  }

  toggleNoteExpand(id: number) {
    this.expandedNotes[id] = !this.expandedNotes[id];
  }

  saveState1 = (state) => {
    if (this.actualState == 0) {
      this.projectService.InsertUpdateGridConfiguration(0, this.gridId, state.filterValue, JSON.stringify(state.columns)).subscribe(result => {
        return state;
      });
    } else if (this.actualState.ID) {
      this.projectService.InsertUpdateGridConfiguration(this.actualState.ID, this.gridId, state.filterValue, JSON.stringify(state.columns)).subscribe(result => {
        return state;
      });
    }
  }

  customizeColumns = (columns) => {
    let result = localStorage.getItem(this.gridId);
    if (result) {
      let data = JSON.parse(result);
      columns.map((col, i) => {
        if (data[i] != undefined) {
          data[i].dataField ? col.dataField = data[i].dataField : '';
          data[i].dataType ? col.dataType = data[i].dataType : '';
          col.visible = data[i].visible;
          col.visibleIndex = data[i].visibleIndex;
          data[i].width ? col.width = data[i].width : '';
        }
      });
    }
  }

  ngOnInit() {
    console.log('SALES DINAMICO ');
    console.log(this.idParent)
    this.initForm()
    this.getDataUSerConnected();

    this.projectService.GetGridConfiguration(this.gridId).subscribe(result => {
      if (result && result.length != 0) {
        this.actualState = result[0];
      } else {
        this.actualState = 0;
      }
      let finalFilter = this.actualState.FILTERCONFIG == "" || this.actualState.FILTERCONFIG == undefined ? null : JSON.parse(this.actualState.FILTERCONFIG);
      let finalColumn = this.actualState.COLUMNCONFIG == "" || this.actualState.COLUMNCONFIG == undefined ? null : JSON.parse(this.actualState.COLUMNCONFIG);
      if (finalFilter) { this.filterValue = finalFilter; }
      if (finalColumn) {
        localStorage.setItem(this.gridId, this.actualState.COLUMNCONFIG);
        if (this.mainGrid) { this.mainGrid.instance.state({}); }
      }
    });
    // this.idParent = this.route.snapshot.queryParamMap.get('numID');
    if (this.idParent) {
      // this.getTaskLis(this.idParent);
      this.getActivityByProjectId();
      this.getSalesLeads()
    } else {
      console.log('No id custumer')
      this.getActivityByProjectId();
    }
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (this.VieneDe == "Sales Leads") {
      if (changes.idParent != undefined) {
        if (changes.idParent.firstChange == false) {
          this.initForm()
          this.getActivityByProjectId()
          this.getSalesLeads()
        }
      }
    }
  }

  // initForm2(){
  //   this._formEntityActivity = new FormGroup({
  //     Hour: new FormControl({ value: '', disabled: false }, []),
  //     Minute: new FormControl({ value: null, disabled: false }, []),
  //     // Customer: new FormControl({ value: this.customerID, disabled: true }, []),
  //     CusomerActivityId: new FormControl({ value: 0, disabled: false }, []),
  //     EmployeeId: new FormControl({ value: 1, disabled: false }, []),
  //     Type: new FormControl({ value: 1, disabled: false }, [Validators.required]),
  //     Notes: new FormControl({ value: '', disabled: false }, []),
  //     StartTime: new FormControl({ value: new Date().getTime(), disabled: false }, [Validators.required]),
  //     EndTime: new FormControl({ value: '', disabled: false }, []),
  //     Follow: new FormControl({ value: '', disabled: false }, []),
  //     Name: new FormControl({ value: '', disabled: false }, [Validators.required]),
  //     Closed: new FormControl({ value: '', disabled: false }, []),
  //     FollowComments: new FormControl({ value: '', disabled: false }, []),
  //     durationDetail: new FormControl({ value: '', disabled: false }, [Validators.required]),
  //     id: new FormControl({ value: 0, disabled: false }, []),
  //   });
  // }

  initForm() {
    // this._formEntityActivity = new FormGroup({
    //   Hour: new FormControl({ value: '', disabled: false }, []),
    //   Minute: new FormControl({ value: null, disabled: false }, []),
    //   // Customer: new FormControl({ value: this.customerID, disabled: true }, []),
    //   CusomerActivityId: new FormControl({ value: 0, disabled: false }, []),
    //   EmployeeId: new FormControl({ value: 1, disabled: false }, []),
    //   Type: new FormControl({ value: 1, disabled: false }, [Validators.required]),
    //   Notes: new FormControl({ value: '', disabled: false }, []),
    //   StartTime: new FormControl({ value: new Date().getTime(), disabled: false }, [Validators.required]),
    //   EndTime: new FormControl({ value: '', disabled: false }, []),
    //   Follow: new FormControl({ value: '', disabled: false }, []),
    //   Name: new FormControl({ value: '', disabled: false }, [Validators.required]),
    //   Closed: new FormControl({ value: '', disabled: false }, []),
    //   FollowComments: new FormControl({ value: '', disabled: false }, []),
    //   durationDetail: new FormControl({ value: '', disabled: false }, [Validators.required]),
    //   id: new FormControl({ value: 0, disabled: false }, []),
    // });

    this._formEntityAssociatePeople = new FormGroup({
      id: new FormControl({ value: 0, disabled: false }, []),
      customerid: new FormControl({ value: this.customerID, disabled: false }, []),
      description: new FormControl({ value: '', disabled: false }, []),
      buyetypeid: new FormControl({ value: 2, disabled: false }, []),
      influenceid: new FormControl({ value: 2, disabled: false }, []),
      contactid: new FormControl({ value: 0, disabled: false }, [Validators.required]),
    })
  }

  currentdate() {
    let f = new Date();
    this.currentyear = f.getFullYear()
    this.currentMont = (f.getFullYear() + 1);
    this.currectDay = (f.getDate());

  }
  newactiviesOpen() {
    let modalOptions = {
      ignoreBackdropClick: true,
      class: 'modal-dialog modal-lg',
      data: {
        customerSelect: this.idParent
      }
    };
    this.modalRef = this.modalService.show(NewActivityGenericComponent, modalOptions);
    this.modalRef.content.action.subscribe((result: any) => {
      // console.clear();
      this.modalRef.hide();
      this.getActivityByProjectId();
    });

  }
  opneModalNewTask() {
    let modalOptions = {
      // backdrop: true,
      // keyboard: true,
      // focus: true,
      // show: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog modal-lg',
      // containerClass: '',
      // animated: true,
      data: {
        customerSelect: this.idParent
      }
    };
    this.modalRef = this.modalService.show(NewTaskModalComponent, modalOptions);

    this.modalRef.content.action.subscribe((result: any) => {
      console.clear();
      this.getTaskLis(this.idParent);



    });
  }
  getTaskLis(id) {
    /**
 *  "row": 1,
      "ITEMID": 26906,
      "NUMBER": "6086",
      "ITEMNAME": "Demo",
      "DUEDATE": "2020-05-05T10:10:59",
      "PRIORITYID": 1,
      "PRIORITY": "High",
      "DURATION": 0.0,
      "NOTES": "",
      "STATUSID": 2,
      "ITEMTYPE": "T",
      "ITEMTYPENAME": "Task",
      "IDTYPE": "Project",
      "PROJECTID": 6086
 */
    this.GeneralService.getPopulateGeneral('Task', id).subscribe(
      result => {
        this.TaskList = result;
        console.log('getTaskLis', result);
      },
      err => {
        console.log(err);
      }
    );
  }

  exitToHome() {
    this.GeneralService.goToHome();
  }

  truncateDate(date: string) {
    let dateFormat = (date + '').substr(0, 10) + ' ' + (date + '').substr(11, 8);
    if (date === "1900-01-01T00:00:00") {
      return ''
    } else {
      return dateFormat
    }
  }
  // aCtiviti list anf filter
  getActivityByProjectId() {
    if (this.from == 'editservice') {
      this.MapInformationService.MethodCallApiFlex({ method: 'Get_SiteActivities', siteid: this.idParent }).subscribe(result => {
        let infoFinal = []
        result.forEach((element, index) => {
          element.CustomerId = element.CUSTOMERID ? element.CUSTOMERID : '';
          element.PROJECTID = element.PROJECTID ? element.PROJECTID : '';
          element.PROJECTNAME = element.PROJECTNAME ? element.PROJECTNAME : 'NOT SET';
          element.DURATION = this.formatDurationActivities(element);
          element.CheckClosed = element.CLOSED == 'No' ? false : true;
          element.StartDateTime = this.checkValidDate(element.DATE)
          element.EndTime = this.checkValidDate(element.EndTime)
          element.FOLLOWUPCOMMENTSsinHTML = element.FOLLOWUPCOMMENTS ? this.eliminarHTML(element.FOLLOWUPCOMMENTS) : ''
          element.ico_SoldYesOrNot = element.BIDSTATUS == 'S' ? 'Yes' : 'No'
          infoFinal.push(element)
        })
        this.TaskListData = infoFinal;
        this.PopupNewActivity = false
      });
      return;
    }
    let info = { method: 'Get_ActivityListByProject', projectid: 0, customerid: 0, startdate: '' }
    if(this.from != 'employeeactivities'){
      if (this.from == 'editprojet') {
        info.projectid = this.idParent
        delete info.customerid
      }
      if (this.from == 'editcustomer') {
        info.customerid = this.idParent
        delete info.projectid
      }
    } else {
      info.method = 'Get_ActivityListByProject'
      info.startdate = this.DateFilter2
      delete info.projectid
      delete info.customerid
    }

    this.MapInformationService.MethodCallApiFlex(info).subscribe(result => {
      // this.MapInformationService.SaveInfoSites({method:"Get_ActivityListByProject",projectid: this.idParent}).subscribe(result => {
      console.log('Lead Activity ', result)
      let infoFinal = []
      result.forEach((element, index) => {
        element.CustomerId = element.CUSTOMERID ? element.CUSTOMERID : '';
        element.PROJECTID = element.PROJECTID ? element.PROJECTID : '';
        element.DURATION = this.formatDurationActivities(element);
        element.CheckClosed = element.CLOSED == 'No' ? false : true;
        element.StartDateTime = this.checkValidDate(element.StartDateTime)
        element.EndTime = this.checkValidDate(element.EndTime)
        element.FOLLOWUPCOMMENTSsinHTML = element.FOLLOWUPCOMMENTS ? this.eliminarHTML(element.FOLLOWUPCOMMENTS) : ''
        // element.ico_SoldYesOrNot = index % 2 == 0 ? 'Yes' : 'No'
        element.ico_SoldYesOrNot = element.BIDSTATUS == 'S' ? 'Yes' : 'No'
        infoFinal.push(element)
      })
      this.TaskListData = infoFinal;
      this.PopupNewActivity = false
    });
  }

  eliminarHTML(cadena) {
    return cadena.replace(/<[^>]+>/g, '');
  }

  formatDuration(element) {
    let duration = ""
    if (element.DURATION != undefined) {
      duration = element.DURATION.toString()

      let hour = element.DURATION.toString().substr(0, 2);
      let minute = element.DURATION.toString().substr(2, 5);

      if (minute == undefined) {
        console.log(hour.length)
        if (hour.length > 1) {
          duration = hour + ":" + "00"
        } else if (hour.length == 1) {
          duration = "0" + hour + ":" + "00"
        }
      } else {
        if (hour.length == 2) {
          if (minute.length == 2) {
            duration = hour + ":" + minute
          } else if (minute.length == 1) {
            duration = hour + ":" + minute + "0"
          }
        } else {
          if (minute.length == 2) {
            duration = "0" + hour + ":" + minute
          } else {
            duration = "0" + hour + ":" + minute + "0"
          }
        }
      }
    }
    return duration;
  }

  checkValidDate(date) {
    let year = this.datepipe.transform(date, 'yyyy');
    if (parseInt(year) < 1990) date = "";
    return date;
  }

  getActivityfiltes(dataFilter) {
    if (this.idParent) {
      this.customerService.GetCustomerActivityEmployeesFilter(dataFilter).subscribe(
        data => {
          console.log('getActivityByCustumer', data);
        },
        err => {
          console.log('Error: ' + err);
        }
      );
    } else {
      console.log('No idCustumer for get Activities')
    }
  }



  titleClick(data) {
    console.log(data)
    this.itemIndex = data.itemIndex;
    console.log(this.itemIndex);
    switch (data.itemIndex) {
      case 1: // "Blog"
        this.getTaskLis(this.idParent);
        break
      case 2: // "Activities"
        this.getActivityByProjectId();
        break
      case 3:

        this.MapInformationService.SaveInfoSites({ id: this.idParent, method: "Get_SalesLead_ByID" })
          .subscribe(result => {
            console.log(result)
            this.customerID = result[0].CUSTOMERREQPRICEID
            this.getAssociatePeople(0)
          })

        break
    }
  }

  GoBack() {
    // routerLink='/salesLeads'
    // this.router.navigateByUrl(`/salesLeads`)
    this.location.back();
  }

  CloseNewActivity() {
    this.PopupNewActivity = false
    this._formEntityActivity = new FormGroup({
      Hour: new FormControl({ value: '', disabled: false }, []),
      Minute: new FormControl({ value: null, disabled: false }, []),
      CusomerActivityId: new FormControl({ value: 0, disabled: false }, []),
      EmployeeId: new FormControl({ value: 1, disabled: false }, []),
      Type: new FormControl({ value: 1, disabled: false }, [Validators.required]),
      Notes: new FormControl({ value: '', disabled: false }, []),
      StartTime: new FormControl({ value: new Date().getTime(), disabled: false }, [Validators.required]),
      EndTime: new FormControl({ value: '', disabled: false }, []),
      Follow: new FormControl({ value: '', disabled: false }, []),
      Name: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Closed: new FormControl({ value: '', disabled: false }, []),
      FollowComments: new FormControl({ value: '', disabled: false }, []),
      durationDetail: new FormControl({ value: '', disabled: false }, [Validators.required]),
      id: new FormControl({ value: 0, disabled: false }, []),
      externalLink: new FormControl({ value: "", disabled: false }, []),
      sort: new FormControl({ value: null, disabled: false }, []),
    });
  }

  SaveNewActivity() {
    let formValue;
    formValue = this._formEntityActivity.value;

    formValue.OptCustomer = 1;
    formValue.OptServiceSite = 0;
    formValue.OptProject = 0;

    // formValue.CustomerId = parseInt(this.customerID);
    // formValue.Customer = parseInt(this.customerID);

    // Change Format date 2020-07-16 to 20200715 11:11 (Concat hour)
    let TMPdate;
    let HourToedit;

    HourToedit = formValue.Hour;
    formValue.StartTime = new Date(formValue.StartTime);
    formValue.EndTime = new Date(formValue.EndTime);

    formValue.Hour = formValue.durationDetail.substr(0, 2);
    formValue.Minute = formValue.durationDetail.substr(2, 5);
    if (formValue.Follow === true) {
      formValue.Follow = parseInt('1');
    } else { formValue.Follow = parseInt('0'); }
    // Close
    if (formValue.Closed === true) {
      formValue.Closed = parseInt('1');
    } else { formValue.Closed = parseInt('0'); }
    // END hange boolean ton strin 0 and 1
    if (formValue.Name === "") {
      formValue.Name = "New Activity";
    }

    formValue.Employee = formValue.EmployeeId
    formValue.ActivityType = formValue.Type
    formValue.method = "SaveActivity"
    // console.log(formValue)
    const data = {
      Close: formValue.Closed,
      EmployeeId: formValue.EmployeeId,
      EndTime: formValue.EndTime,
      Follow: formValue.Follow,
      FollowComments: formValue.FollowComments,
      Hour: formValue.Hour,
      Minute: formValue.Minute,
      Name: formValue.Name,
      Notes: formValue.Notes,
      OptProject: 1,
      ProjectId: this.idParent,
      StartDateTime: formValue.StartTime,
      Type: formValue.Type,
      id: formValue.id,
      CusomerActivityId: formValue.CusomerActivityId
    }
    this.customerService.PostInsertUpdateCustomerActivity(data).subscribe(
      // this.MapInformationService.SaveInfoSites(formValue).subscribe(
      data => {
        this.toast.success(this.translate.instant('ModalEditSalesLeads.msgAcCreSucc'));
        this.CloseNewActivity()
        this.getActivityByProjectId()
      }, err => {
        console.log(err)
      })

  }

  OpenNewActivity() {
    this.GetinfoSelect()
    this.PopupNewActivity = true
  }

  NewOpenNewActivity(campo = undefined) {
    if (campo != undefined) {
      this.NewService = true
    }
    this.initFormActivities()
    this.getInfoActivity()
    this.PopupNewActivity = true
  }

  GetinfoSelect() {
    this.customerService.GetCustomerActivityEmployees().subscribe(
      data => {
        this.optionsPeople = data.map((val) => {
          // console.log(val.value)
          return { // Return the new object structure
            label: val.value,
            value: val.ID
          };
        });
        console.log(this.optionsPeople)
      })
    this.customerService.GetCustomerActivityType().subscribe(
      data => {
        this.optionsCType = data.map((val) => {
          return { // Return the new object structure
            label: val.Name,
            value: val.ID
          };
        });
      },
      err => {
        console.log(err)
      }
    );
  }

  editActivity(data) {
    this.initForm()
    let infoForm = data.data
    this.customerService.GetCustomerActivityEmployees().subscribe(
      data => {
        this.optionsPeople = data.map((val) => {
          // console.log(val.value)
          return { // Return the new object structure
            label: val.value,
            value: val.ID
          };
        });
        this.customerService.GetCustomerActivityType().subscribe(
          data => {
            this.optionsCType = data.map((val) => {
              return { // Return the new object structure
                label: val.Name,
                value: val.ID
              };
            });
          },
          err => {
            console.log(err)
          }
        );
      })
    // this._formEntityActivity.get('CusomerActivityId').setValue(infoForm.ID)
    // this._formEntityActivity.get('Type').setValue(infoForm.TYPEID)
    // this._formEntityActivity.get('EmployeeId').setValue(infoForm.EMPLOYEEID)
    // this._formEntityActivity.get('Notes').setValue(infoForm.NOTES)
    // this._formEntityActivity.get('StartTime').setValue(new Date(infoForm.STARTTIME).getTime())
    // this._formEntityActivity.get('EndTime').setValue(new Date(infoForm.EndTime).getTime())
    // this._formEntityActivity.get('Follow').setValue(infoForm.FOLLOWUP == "No" ? false:true)
    // this._formEntityActivity.get('Name').setValue(infoForm.NAME)
    // this._formEntityActivity.get('Closed').setValue(infoForm.CLOSED == "No" ? false:true)
    // this._formEntityActivity.get('FollowComments').setValue(infoForm.FOLLOWUPCOMMENTS)
    // this._formEntityActivity.get('id').setValue(infoForm.ID)
    // this._formEntityActivity.get('externalLink').setValue("")


    let duration = ""
    if (infoForm.DURATION != undefined) {
      duration = infoForm.DURATION.toString().split(":")
      if (duration[1] == undefined) {
        console.log(duration[0].length)
        if (duration[0].length == 2) {
          duration = duration[0] + "00"
        } else {
          duration = "0" + duration[0] + "00"
        }
      } else {
        if (duration[0].length == 2) {
          if (duration[1].length == 2) {
            duration = duration[0] + duration[1]
          } else {
            duration = duration[0] + duration[1] + "0"
          }
        } else {
          if (duration[1].length == 2) {
            duration = "0" + duration[0] + duration[1]
          } else {
            duration = "0" + duration[0] + duration[1] + "0"
          }
        }
      }
    }
    console.log(duration)
    // this._formEntityActivity.get('durationDetail').setValue(duration)

    this._formEntityActivity = new FormGroup({
      Hour: new FormControl({ value: '', disabled: false }, []),
      Minute: new FormControl({ value: null, disabled: false }, []),
      CusomerActivityId: new FormControl({ value: infoForm.ID, disabled: false }, []),
      EmployeeId: new FormControl({ value: infoForm.EMPLOYEEID, disabled: false }, []),
      Type: new FormControl({ value: infoForm.TYPEID, disabled: false }, [Validators.required]),
      Notes: new FormControl({ value: infoForm.NOTES, disabled: false }, []),
      StartTime: new FormControl({ value: new Date(infoForm.STARTTIME).getTime(), disabled: false }, [Validators.required]),
      EndTime: new FormControl({ value: new Date(infoForm.EndTime).getTime(), disabled: false }, []),
      Follow: new FormControl({ value: infoForm.FOLLOWUP, disabled: false }, []),
      Name: new FormControl({ value: infoForm.NAME, disabled: false }, [Validators.required]),
      Closed: new FormControl({ value: infoForm.CLOSED, disabled: false }, []),
      FollowComments: new FormControl({ value: infoForm.FOLLOWUPCOMMENTS, disabled: false }, []),
      durationDetail: new FormControl({ value: duration, disabled: false }, [Validators.required]),
      id: new FormControl({ value: infoForm.ID, disabled: false }, []),
      externalLink: new FormControl({ value: "", disabled: false }, []),
      sort: new FormControl({ value: infoForm.SORT, disabled: false }, []),
    });

    this.PopupNewActivity = true
  }

  closeActivity(e, data) {
    console.log('Evento ', e);
    console.log('Data Grid ', data);
    let newData = data.data;
    newData.CLOSED = e.value == false ? 'No' : 'Yes';


    const dataFinal = {
      "id": data.data.ID,
      "activityid": data.data.ID,
      "closed": e.value == false ? 0 : 1,
      "projectid": this.idParent,
      "method": "UpdateCloseActivity",
    }

    this.MapInformationService.SaveInfoSites(dataFinal)
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModalEditSalesLeads.msgActTemCreSucc'));
        this.getActivityByProjectId();
      })



    // this.setFormActivities(newData, true);
    // setTimeout(() => {
    //   this.saveActivities();
    // }, 800);
  }

  openPopupSend() {
    this.sendProjectPoPup = true
    this.IDSalesSend = this.idParent
  }

  // sendProject(){
  //   console.log(this.IDSalesSend)
  //   const data={
  //     method:'ConvertLeadToProject',
  //     projectid:this.IDSalesSend
  //   }
  //   this.MapInformationService.SaveInfoSites(data)
  //   .subscribe(resp=>{
  //     console.log(resp)
  //     this.toast.success("The Sales Lead has been converted to an Estimate.")
  //     this.IDSalesSend = ""
  //     this.sendProjectPoPup = false
  //     this.Converted.emit(true);
  //   })
  // }
  sendProject() {
    console.log(this.IDSalesSend)


    this.projectid = this.IDSalesSend
    console.log(this.AddPipe)
    if (this.AddPipe) {
      this.getProbability()
      this.openModalPipe()
      this.getRaiting()
      this.AddPipe = false
    } else {
      const data = {
        method: 'ConvertLeadToProject',
        projectid: this.IDSalesSend
      }
      this.MapInformationService.SaveInfoSites(data)
        .subscribe(resp => {
          console.log(resp)
          this.toast.success(this.translate.instant('ModalEditSalesLeads.msgConEst'));
          this.IDSalesSend = ""
          this.sendProjectPoPup = false
          this.Converted.emit(true);
          this.GoBack()
        })
    }
  }

  initPipelineModel() {
    this.addToPipelineModel = {
      estclosedate: this.datePipe.transform(new Date(), 'yyyyMMdd'),
      probabilityid: 0,
      criteriaid: 0,
      id: 0,
      projectid: this.projectid,
      customerid: 0,
      howfound: '',
      opendate: this.datePipe.transform(new Date(), 'yyyyMMdd'),
      employeeid: 0,
      closed: 0
    };
  }

  openModalPipe() {
    let projectDetail
    let model = {
      PageIndex: 1,
      PageSize: 20,
      OrderID: 1,
      ProjectNumber: '',
      ProjectId: this.projectid,
      ProjectName: '',
      Amount: '',
      BidDate: '',
      BidStatus: '',
      CloseDate: '',
      CustomerName: '',
      SalesPerson: '',
      SalesCategory: ''
    };
    this.salesLeadsService.GetSalesProject(model).subscribe(result => {
      console.log('alo??')
      console.log(result)
      console.log(result.data[0])
      projectDetail = result.data[0]
      this.settingsCompany.GetClientSettings("DefaultOportunityProbabilityID").subscribe(data => {
        this.addToPipelineModel.probabilityid = Number(data[0].VALUE);
        this.popupAddPipeline = true
      })
    })
  }

  getProbability() {
    this.pipelineService.GetOpportunityProbability().subscribe(result => {
      this.probabilitySelect = result;
      Array.prototype.forEach.call(this.probabilitySelect, probability => {
        console.log(probability)
        let porcentaje = probability.ID - 1
        probability['probabilyfull'] = `${probability.DESCRIPTION} (${porcentaje}0%)`
      })
    })
  }

  getRaiting() {
    this.pipelineService.GetOportunityType().subscribe(result => {
      this.raitingSelect = result;
    });
  }

  addToPipeline() {
    if (typeof (this.addToPipelineModel.estclosedate) === 'number') {
      this.addToPipelineModel.estclosedate = this.datePipe.transform(this.addToPipelineModel.estclosedate, 'yyyyMMdd');
    }
    this.addToPipelineModel.projectid = this.projectid;
    this.MapInformationService.SaveInfoSites({ method: "Get_ClientSettingsByName", name: "DefaultOportunityFunnelID" })
      .subscribe(informacion => {
        let infoFinal
        if (informacion.length > 0) {
          infoFinal = {
            customerid: this.addToPipelineModel.customerid,
            howfound: this.addToPipelineModel.howfound,
            employeeid: this.addToPipelineModel.employeeid,
            estclosedate: this.addToPipelineModel.estclosedate,
            probabilityid: this.addToPipelineModel.probabilityid,
            ratingid: informacion[0].VALUE,
            closed: this.addToPipelineModel.closed,
            criteriaid: this.addToPipelineModel.criteriaid,
            description: "",
            projectid: this.addToPipelineModel.projectid,
            comments: "",
            id: this.addToPipelineModel.id,
            method: "Update_ProjectOpportunity"
          }
        } else {
          infoFinal = {
            customerid: this.addToPipelineModel.customerid,
            howfound: this.addToPipelineModel.howfound,
            employeeid: this.addToPipelineModel.employeeid,
            estclosedate: this.addToPipelineModel.estclosedate,
            probabilityid: this.addToPipelineModel.probabilityid,
            ratingid: 0,
            closed: this.addToPipelineModel.closed,
            criteriaid: this.addToPipelineModel.criteriaid,
            description: "",
            projectid: this.addToPipelineModel.projectid,
            comments: "",
            id: this.addToPipelineModel.id,
            method: "Update_ProjectOpportunity"
          }
        }
        console.log(infoFinal)
        this.MapInformationService.SaveInfoSites(infoFinal).subscribe(res => {
          const data = {
            method: 'ConvertLeadToProject',
            projectid: this.IDSalesSend
          }
          this.MapInformationService.SaveInfoSites(data)
            .subscribe(resp => {
              console.log(resp)
              this.toast.success(this.translate.instant('ModalEditSalesLeads.msgConEst'));
              this.IDSalesSend = ""
              this.sendProjectPoPup = false
              this.popupAddPipeline = false
              this.Converted.emit(true);
            })
        })
      })
  }

  setNewActivityType(event) {
    this._formEntityActivity.get("Type").setValue(event[0].ReturnID)
  }

  //Test Activity

  //1

  initFormActivities() {
    this._formEntityActivity = new FormGroup({
      Id: new FormControl({ value: 0, disabled: false }, []),
      OptCustomer: new FormControl({ value: this.from == 'editcustomer' ? 1 : 0, disabled: false }, []),
      OptServiceSite: new FormControl({ value: this.from == 'editservice' ? 1 : 0, disabled: false }, []),
      OptProject: new FormControl({ value: this.from == 'editprojet' ? 1 : 0, disabled: false }, []),
      Hour: new FormControl({ value: new Date(), disabled: false }, [Validators.required]),
      Minute: new FormControl({ value: null, disabled: false }, [Validators.required]),
      ProjectId: new FormControl({ value: this.from == 'editprojet' ? this.idParent : 0, disabled: false }, []),
      // CusomerActivityId: new FormControl({ value: null, disabled: false }, []),
      EmployeeId: new FormControl({ value: 1, disabled: false }, [Validators.required]),
      Type: new FormControl({ value: 1, disabled: false }, [Validators.required]),
      Notes: new FormControl({ value: '', disabled: false }, []),
      StartDateTime: new FormControl({ value: new Date(), disabled: false }, [Validators.required]),
      EndTime: new FormControl({ value: '', disabled: false }, []),
      Follow: new FormControl({ value: 0, disabled: false }, []),
      Name: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Close: new FormControl({ value: 0, disabled: false }, []),
      CustomerId: new FormControl({ value: this.from == 'editcustomer' ? this.idParent : 0, disabled: false }, []),
      ServiceSiteId: new FormControl({ value: this.from == 'editservice' ? this.idParent : 0, disabled: false }, []),
      FollowComments: new FormControl({ value: '', disabled: false }, []),
      CustomerName: new FormControl({ value: '', disabled: false }, []),
      externalLink: new FormControl({ value: '', disabled: false }, []),
      durationDetail: new FormControl({ value: '', disabled: false }, [Validators.required]),
      sort: new FormControl({ value: null, disabled: false }),
    });

    // Hour: new FormControl({ value: '', disabled: false }, [Validators.required]),
    //   Minute: new FormControl({ value: null, disabled: false }, [Validators.required]),
    //   // Customer: new FormControl({ value: this.customerID, disabled: true }, []),
    //   CusomerActivityId: new FormControl({ value: 0, disabled: false }, []),
    //   EmployeeId: new FormControl({ value: 1, disabled: false }, []),
    //   Type: new FormControl({ value: 1, disabled: false }, [Validators.required]),
    //   Notes: new FormControl({ value: '', disabled: false }, []),
    //   StartTime: new FormControl({ value: new Date().getTime(), disabled: false }, [Validators.required]),
    //   EndTime: new FormControl({ value: '', disabled: false }, []),
    //   Follow: new FormControl({ value: '', disabled: false }, []),
    //   Name: new FormControl({ value: '', disabled: false }, []),
    //   Closed: new FormControl({ value: '', disabled: false }, []),
    //   FollowComments: new FormControl({ value: '', disabled: false }, []),
    //   durationDetail: new FormControl({ value: '', disabled: false }, []),
    //   id: new FormControl({ value: 0, disabled: false }, []),
  }

  //2

  getInfoActivity() {
    this.customerService.GetCustomerActivityEmployees().subscribe(
      data => {
        this.optionsPeople = data.map((val) => {
          // console.log(val.value)
          return { // Return the new object structure
            label: val.value,
            value: val.ID
          };
        });
        console.log(this.optionsPeople)
      })
    this.customerService.GetCustomerActivityType().subscribe(
      data => {
        this.optionsCType = data.map((val) => {
          return { // Return the new object structure
            label: val.Name,
            value: val.ID
          };
        });
      },
      err => {
        console.log(err)
      }
    );
  }


  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      template: 'buttonsRight'
    },
    {
      location: 'before',
      template: 'buttonsLeft'
    }
  );
  }

  //3


  setFormActivities(val, hidePopup = undefined) {

    this.dataForm = []
    this.PopupNewActivity = true
    setTimeout(() => {
      
      this.dataForm = val
    }, 500);


  }

  //4

  saveActivities() {
    let formValue;
    formValue = this._formEntityActivity.value;
    if (!formValue.Name) {
      this.toast.warning(this.translate.instant('ModalEditSalesLeads.msgActName'));
      return;
    }
    console.log('Form Original ', this._formEntityActivity.value)
    formValue.ProjectId = this.from == 'editprojet' ? parseInt(this.idParent) : 0;
    formValue.CustomerId = this.from == 'editcustomer' ? parseInt(this.idParent) : 0;
    console.log('Form Value ', formValue)
    // Change Format date 2020-07-16 to 20200715 11:11 (Concat hour)
    let TMPdate;
    let HourToedit;
    // TMPdate = formValue.StartDateTime.replace('-', "");
    // TMPdate = TMPdate.replace('-', "") + " " + formValue.Hour;
    HourToedit = formValue.Hour;
    formValue.StartDateTime = formValue.StartDateTime !== "" && null && undefined ? this.datePipe.transform(formValue.StartDateTime, 'yyyy-MM-dd') : '';
    formValue.StartDateTime = formValue.StartDateTime !== "" && null && undefined ? formValue.StartDateTime + ` ${formValue.Hour.getHours()}:${formValue.Hour.getMinutes()}` : '';
    formValue.EndTime = formValue.EndTime !== "" && null && undefined ? this.datePipe.transform(formValue.EndTime, 'yyyy-MM-dd') : '';
    formValue.EndTime = formValue.EndTime !== "" && null && undefined ? formValue.EndTime + ` ${formValue.Hour.getHours()}:${formValue.Hour.getMinutes()}` : '';

    console.log('Work Completed ', this.workcompleteddate)
    formValue.DateFollow = this.followUpDate ? this.datePipe.transform(new Date(this.followUpDate), 'yyyy-MM-dd') : '';
    formValue.DateFollow = formValue.DateFollow + ` ${formValue.Hour.getHours()}:${formValue.Hour.getMinutes()}`

    let starttime = this.workcompleteddate ? this.datePipe.transform(new Date(this.workcompleteddate), 'yyyy-MM-dd') : '';
    console.log('Start Time ', starttime);
    let minute = formValue.Minute;
    formValue.Hour = formValue.durationDetail.substr(0, 2);
    formValue.Minute = formValue.durationDetail.substr(2, 5);
    // Change boolean ton strin 0 and 1
    if (formValue.Follow == true) {
      formValue.Follow = parseInt('1');
    } else if (formValue.Follow == false) { formValue.Follow = parseInt('0'); }

    if (formValue.Close == true) {
      formValue.Close = parseInt('1');
    } else if (formValue.Close == false) { formValue.Close = parseInt('0'); }

    console.log(this.NewService)

    if (this.NewService) {
      let data = {
        id: formValue.Id,
        customerid: formValue.OptCustomer,
        servicesiteid: formValue.OptServiceSite,
        employeeid: formValue.EmployeeId,
        date: formValue.id,
        type: formValue.Type,
        notes: formValue.Notes,
        starttime: starttime,
        endtime: formValue.EndTime,
        followup: formValue.Follow,
        // followupdate:formValue.id,
        name: formValue.Name,
        // duedate:formValue.id,
        // completiondate:formValue.id,
        // completionpercenr:formValue.id,
        closed: formValue.Close,
        followupcomments: formValue.FollowComments,
        // intvalue:formValue.id,
        // marketcampid:formValue.id,
        projectid: formValue.ProjectId,
        duration: formValue.durationDetail,
        // externallink:formValue.id,
        method: "InsertUpdate_ActivityTemplate"
      }

      this.MapInformationService.SaveInfoSites(data)
        .subscribe(resp => {
          this.toast.success(this.translate.instant('ModalEditSalesLeads.msgActTemCreSucc'));
          this.getActivityByProjectId();
          this.PopupNewActivity = false;
          this.NewService = false
        })
    } else {

      let durationFinal
      if (formValue.Hour != undefined && formValue.Minute != undefined) {
        durationFinal = formValue.Hour + "." + formValue.Minute
      }

      let data = {
        id: formValue.Id,
        customerid: formValue.CustomerId,
        servicesiteid: null,
        employeeid: formValue.EmployeeId,
        type: formValue.Type,
        notes: formValue.Notes,
        starttime: starttime,
        endtime: formValue.DateFollow,
        followup: formValue.Follow,
        followupdate: formValue.DateFollow,
        name: formValue.Name,
        closed: formValue.Close,
        followupcomments: formValue.FollowComments,
        projectid: formValue.ProjectId,
        duration: durationFinal != undefined ? Number(durationFinal) : 0.0,
        externallink: formValue.externalLink,
        sort: formValue.sort,
        method: "InsertUpdateActivity",
      }
      console.log('Actualizando ', data);
      // this.MapInformationService.InsertUpdateActivity(formValue).subscribe(result => {
      this.MapInformationService.SaveInfoSites(data).subscribe(result => {
        this.toast.success(this.translate.instant('ModalEditSalesLeads.msgAcCreSucc'));
        this.getActivityByProjectId();
        this.PopupNewActivity = false;
        this.NewService = false
      },
        error => {
          console.log(error)
          this.PopupNewActivity = false;
        });

    }
  }


  OpenImport() {
    let tampleatesInfo = {
      method: "Get_ActivityTemplate",
    };
    this.infoTemplate = [];
    this.MapInformationService.SaveInfoSites(tampleatesInfo).subscribe(
      (res) => {
        console.log(res)
        this.infoTemplate = res.map(x => {
          x.closedYesOrNot = x.CLOSED == true ? "Yes" : "No"
          return x
        })
        this.openImport = true
      }
    );

  }

  DeselectAll() {
    this.openImport = false
    this.GridTemplate.instance.deselectAll()
  }

  SaveInfo() {
    let data = this.GridTemplate.instance.getSelectedRowsData()
    if (data.length > 0) {
      console.log(data)

      let contador = 0
      data.forEach(e => {

        let Hour = "00";
        let Minute = "00";
        let durationFinal
        if (e.DURATION != undefined) {
          Hour = e.DURATION.toString().substr(0, 2);
          Minute = e.DURATION.toString().substr(2, 5);
        }

        durationFinal = Hour + "." + Minute

        let test = {
          id: 0,
          customerid: this.from == 'editcustomer' ? this.idParent : 0,
          servicesiteid: this.from == 'editservice' ? this.idParent : 0,
          employeeid: e.EMPLOYEEID,
          type: e.TYPE == null || e.TYPE == 0 ? 1 : e.TYPE,
          notes: e.NOTES,
          starttime: e.STARTTIME == null ? "" : e.STARTTIME,
          endtime: e.ENDTIME,
          followup: e.FOLLOWUP == true ? 1 : 0,
          followupdate: new Date(),
          name: e.NAME,
          closed: e.CLOSED == true ? 1 : 0,
          followupcomments: e.FOLLOWUPCOMMENTS,
          projectid: this.from == 'editprojet' ? this.idParent : 0,
          duration: Number(durationFinal),
          externallink: e.EXTERNALLINK,
          method: "InsertActivityImport",
        }

        console.log('Guardando Data ', test)
        // this.MapInformationService.InsertUpdateActivity(test).subscribe(result => {
        this.MapInformationService.SaveInfoSites(test).subscribe(result => {
          contador++
          if (contador == data.length) {
            this.toast.success(this.translate.instant('ModalEditSalesLeads.msgRegLoadSucc'));
            this.openImport = false
            this.GridTemplate.instance.deselectAll()
            this.getActivityByProjectId()
          }
        }, error => {
          console.log(error)
        });
      })
    } else {
      this.toast.warning(this.translate.instant('ModalEditSalesLeads.msgSelReg'));
    }
  }

  openTemplate() {

  }


  OpenNewEditTemplate(reload = undefined) {

    this.MapInformationService.SaveInfoSites({ method: "Get_ActivityTemplate" })
      .subscribe(resp => {
        console.log(resp)
        this.dataCreateTemplate = []
        this.dataCreateTemplate = resp.map(x => {
          x.DURATION = this.formatDuration(x);
          x.closedYesOrNot = x.CLOSED == true ? "Yes" : "No"
          return x
        })
        if (reload == undefined) {
          this.openNewEditTemplateModal = true
          this.getActivityType()
          this.getEmployeesActivity()
        }
      })
  }

  CloseModal() {
    this.openNewEditTemplateModal = false
  }

  getActivityType() {

    this.customerService.GetCustomerActivityType().subscribe(
      data => {
        this.optionsCType = data.map((val) => {
          return { // Return the new object structure
            label: val.Name,
            value: val.ID
          };
        });
        console.log(this.optionsCType)
        this.ValueOriginal = this.optionsCType
      },
      err => {
        console.log(err)
      }
    );
  }

  InsertinfoDinamica(event) {
    if (event.key.DURATION.includes(':')) {
      let hour = event.key.DURATION.toString().substr(0, 2);
      let minute = event.key.DURATION.toString().substr(3, 5);
      hour = hour.replace(' ', 0);
      minute = minute.replace(' ', 0);
      event.key.DURATION = hour + minute
    }

    console.log(event.key)
    let dataFinal = {
      id: 0,
      customerid: this.from == 'editcustomer' ? this.idParent : 0,
      servicesiteid: this.from == 'editservice' ? this.idParent : 0,
      employeeid: event.key.EMPLOYEEID,
      date: event.key.DATE,
      type: event.key.TYPE === undefined ? 1 : event.key.TYPE,
      notes: event.key.NOTES,
      starttime: event.key.STARTTIME,
      endtime: event.key.ENDTIME,
      followup: event.key.FOLLOWUP == true ? 1 : 0,
      // followupdate:event.key.id,
      name: event.key.NAME,
      // duedate:event.key.id,
      // completiondate:event.key.id,
      // completionpercenr:event.key.id,
      closed: event.key.CLOSED == true ? 1 : 0,
      followupcomments: event.key.FOLLOWUPCOMMENTS,
      // intvalue:event.key.id,
      // marketcampid:event.key.id,
      projectid: this.from == 'editprojet' ? this.idParent : 0,
      duration: event.key.DURATION,
      externallink: event.key.EXTERNALLINK,
      title: event.key.TITLE,
      // externallink:event.key.id,
      method: "InsertUpdate_ActivityTemplate"
    }
    console.log(event.key)
    console.log(dataFinal)
    this.MapInformationService.SaveInfoSites(dataFinal)
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModalEditSalesLeads.msgRegUpSucc'));
        this.OpenNewEditTemplate("reload")
      })
  }

  UpdateinfoDinamica(event) {
    console.log(event)
    if (event.key.DURATION.includes(':')) {
      let hour = event.key.DURATION.toString().substr(0, 2);
      let minute = event.key.DURATION.toString().substr(3, 5);
      hour = hour.replace(' ', 0);
      minute = minute.replace(' ', 0);
      event.key.DURATION = hour + minute
    }

    console.log(event.key)
    // console.log(hour)
    // console.log(minute)

    let dataFinal = {
      id: event.key.ID,
      customerid: event.key.CUSTOMERID,
      servicesiteid: event.key.SERVICESITEID,
      employeeid: event.key.EMPLOYEEID,
      date: event.key.DATE,
      type: event.key.TYPE,
      notes: event.key.NOTES,
      starttime: event.key.STARTTIME,
      endtime: event.key.ENDTIME,
      followup: event.key.FOLLOWUP == true ? 1 : 0,
      // followupdate:event.key.id,
      name: event.key.NAME,
      // duedate:event.key.id,
      // completiondate:event.key.id,
      // completionpercenr:event.key.id,
      closed: event.key.CLOSED == true ? 1 : 0,
      followupcomments: event.key.FOLLOWUPCOMMENTS,
      // intvalue:event.key.id,
      // marketcampid:event.key.id,
      projectid: event.key.PROJECTID,
      duration: event.key.DURATION,
      externallink: event.key.EXTERNALLINK,
      title: event.key.TITLE,
      method: "InsertUpdate_ActivityTemplate"
    }
    console.log(event.key)
    console.log(dataFinal)
    this.MapInformationService.SaveInfoSites(dataFinal)
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModalEditSalesLeads.msgRegUpSucc'));
        this.OpenNewEditTemplate("reload")
      })
  }

  getEmployeesActivity() {
    this.customerService.GetCustomerActivityEmployees().subscribe(
      data => {
        this.optionsPeople = data.map((val) => {
          // console.log(val.value)
          return { // Return the new object structure
            label: val.value,
            value: val.ID
          };
        });
        console.log(this.optionsPeople)
      })
  }

  DeleteServiceActivity(data) {
    console.log(data)
    this.popupDeleteActivity = true
    this.idActivity = data.data.ID
  }

  deleteActivity() {
    this.MapInformationService.SaveInfoSites({ method: "Delete_ActivityListByProject", id: this.idActivity })
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModalEditSalesLeads.msgRegDel'));
        this.popupDeleteActivity = false
        this.getActivityByProjectId()
      })
  }

  deleteDetail(event) {
    console.log(event)
    this.MapInformationService.SaveInfoSites({ method: "Delete_ActivityTemplateByID", id: event.data.ID })
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModalEditSalesLeads.msgRegDel'));
        this.OpenNewEditTemplate("reload")
      })
  }

  formatDurationActivities(element) {
    let duration = ""
    if (element.DURATION != undefined) {
      duration = element.DURATION.toString().split(".")
      if (duration[1] == undefined) {
        console.log(duration[0].length)
        if (duration[0].length > 1) {
          duration = duration[0] + ":" + "00"
        } else if (duration[0].length == 1) {
          duration = "0" + duration[0] + ":" + "00"
        }
      } else {
        if (duration[0].length == 2) {
          if (duration[1].length == 2) {
            duration = duration[0] + ":" + duration[1]
          } else if (duration[1].length == 1) {
            duration = duration[0] + ":" + duration[1] + "0"
          }
        } else {
          if (duration[1].length == 2) {
            duration = "0" + duration[0] + ":" + duration[1]
          } else {
            duration = "0" + duration[0] + ":" + duration[1] + "0"
          }
        }
      }
    }
    return duration;
  }

  goToCalendar() {
    this.router.navigateByUrl(`/salesLeads?showCalendar=Yes`)
  }

  onsubmitActivity(event) {
    console.log(event)
  }


  openFullScreenNote: boolean = false
  note: any = ""
  dataSelected: any

  showEditNotes(data) {
    console.log(data)
    this.note = data.NOTES
    this.dataSelected = data
    this.openFullScreenNote = true
  }


  asignarValueFllow(event) {
    this.note = event.value
  }

  saveNote() {
    console.log(this.note)
    console.log(this.dataSelected)

    const dataFinal = {
      "id": this.dataSelected.ID,
      "notes": this.note,
      "method": "InsertUpdate_ActivityTemplate"
    }

    this.MapInformationService.SaveInfoSites(dataFinal)
      .subscribe(resp => {
        this.toast.success("Updated Successfully")
        this.openFullScreenNote = false
        this.getTemplate()
      })

  }

  getTemplate() {
    this.MapInformationService.SaveInfoSites({ method: "Get_ActivityTemplate" })
      .subscribe(resp => {
        console.log(resp)
        this.dataCreateTemplate = []
        this.dataCreateTemplate = resp.map(x => {
          x.DURATION = this.formatDuration(x);
          x.closedYesOrNot = x.CLOSED == true ? "Yes" : "No"
          return x
        })
      })
  }



  // customer contacts reletionship

  OpenNewAssociatePeopple() {
    let mythis = this
    this.contactDataSource = []
    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName", loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
    this.PopupNewAssociatePeopple = true
  }

  CloseNewAssociatePeopple() {
    this.contactDataSource = []
    this.newRequestBySelect.placeholder = "Select.."
    this.PopupNewAssociatePeopple = false
    this.NameContact = ""
    this._formEntityAssociatePeople = new FormGroup({
      id: new FormControl({ value: 0, disabled: false }, []),
      customerid: new FormControl({ value: this.customerID, disabled: false }, []),
      description: new FormControl({ value: '', disabled: false }, []),
      buyetypeid: new FormControl({ value: 2, disabled: false }, []),
      influenceid: new FormControl({ value: 2, disabled: false }, []),
      contactid: new FormControl({ value: '', disabled: false }, [Validators.required]),
    })
  }

  SaveNewAssociatePeople() {
    this._formEntityAssociatePeople.value.method = "Insert_MultipleCustomer_To_Contacts"
    this._formEntityAssociatePeople.value.customerid = this.customerID



    this._formEntityAssociatePeople.value.buyertypeId = this._formEntityAssociatePeople.value.buyetypeid
    this._formEntityAssociatePeople.value.infuenceid = this._formEntityAssociatePeople.value.influenceid

    if (this._formEntityAssociatePeople.value.id == 0 || this._formEntityAssociatePeople.value.id == undefined) {
      this.MapInformationService.SaveInfoSites(this._formEntityAssociatePeople.value).subscribe(
        // this.customerService.PostInsertCustomerContacts(this._formEntityAssociatePeople.value).subscribe(
        data => {
          // if (data[0].Result) {
          this.toast.success(this.translate.instant('msgAssPeopCreSucc'));
          this.CloseNewAssociatePeopple();
          this.getAssociatePeople(0)
          this.contactDataSource = []
          this.newRequestBySelect.placeholder = "Select.."
          // } else {
          //   this.toast.error('Error Creating Associate People');
          // }
        },
        err => {
        }
      )

    } else {
      this.customerService.EditInsertCustomerContacts(this._formEntityAssociatePeople.value).subscribe(
        data => {
          this.toast.success(this.translate.instant('msgAssPeopCreSucc'));
          this.CloseNewAssociatePeopple();
          this.getAssociatePeople(0)
          this.contactDataSource = []
          this.newRequestBySelect.placeholder = "Select.."
        },
        err => {
        }
      )
    }

    this.contactDataSource = []
  }


  getAssociatePeople(deleted, action?) {
    if (deleted == 0 && action == null) {
      this.checkBoxShowActive = true;
      deleted = 0;
      // this.checkBoxShowInactive = false;
    } else if (action == null) {
      this.checkBoxShowActive = false;
      deleted = 1;
      // this.checkBoxShowInactive = true;
    }

    const info = {
      method: "Get_Customer_Contacts",
      customerid: this.customerID,
      deleted: deleted
      // customerid: "1164"
    }
    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        this.AssociatePeopple = resp.filter((valor, indice) => {
          return valor.CONTACTID != undefined;
        }
        );
        this.customerService.GetCustomerBuyerType().subscribe(result => {
          this.optionsType = result.map((val) => {
            return { // Return the new object structure
              label: val.DESCRIPTION,
              value: val.ID
            };
          });
          this.customerService.GetCustomerOportunityInfluence().subscribe(result => {
            this.optionsInfluence = result.map((val) => {
              return { // Return the new object structure
                label: val.DESCRIPTION,
                value: val.ID
              };
            });
            let mythis = this
          });
        });
      })
  }

  OpenNewContact() {
    this.popupNewContact = true
  }

  editAssociatePeopple(data) {
    const info = {
      id: data.data.ID,
      customerid: this.customerID == undefined ? 0 : this.customerID,
      // CustomerId: "1164",
      description: data.data.DESCRIPTION == undefined ? "" : data.data.DESCRIPTION,
      buyertypeId: data.data.BUYERTYPEID == undefined ? 0 : data.data.BUYERTYPEID,
      infuenceid: data.data.INFLUENCEID == undefined ? 0 : data.data.INFLUENCEID,
      contactid: data.data.CONTACTID == undefined ? 0 : data.data.CONTACTID,
      method: "Insert_MultipleCustomer_To_Contacts"
    }

    this.customerService.EditInsertCustomerContacts(info).subscribe(
      data => {
        if (data[0].Result) {
          this.toast.success(this.translate.instant('msgEditAssPeopSucc'));
          this.getAssociatePeople(0, true)
        } else {
          this.toast.error('Error Edited Associate People');
        }
      },
      err => {
      }
    )
    this.contactDataSource = []
  }

  InicioEditPeople(event) {
    let mythis = this
    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName", loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  customOperations: Array<any>;
  popupPosition: any;

  DeleteADocument(event) {
    let info = {
      method: "Delete_Customer_Contacts",
      customerid: this.customerID,
      contactid: event.key.CONTACTID,
    }
    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        this.toast.success("Registry deleted successfully")
        this.getAssociatePeople(0, true)
      })
  }

  selectContact(item) {
    if (item.selectedItem != undefined) {
      this.NameContact = item.selectedItem.label
      this._formEntityAssociatePeople.get("contactid").setValue(item.selectedItem.ID)
    }
  }

  GoToContact(data) {
    this.router.navigate(['/contacts/editContact/' + data.data.CONTACTID]);
  }


  emailPopup: boolean = false

  onItemsClickCommands(e) {
    switch (e.itemData.id) {
      case 1:
        if (this.showSendEmail) {
          this.emailPopup = true
        } else {
          this.showEmailConfigPopup = true;
        }
        break;
      case 2:
        // this.SearchPart()
        break;
    }
  }


  setFormCustomer(data) {
    console.log(data)

    let mythis = this
    this.contactDataSource = []
    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName", loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });



    this._formEntityAssociatePeople = new FormGroup({
      id: new FormControl({ value: data.ID, disabled: false }, []),
      customerid: new FormControl({ value: this.customerID, disabled: false }, []),
      description: new FormControl({ value: data.DESCRIPTION, disabled: false }, []),
      buyetypeid: new FormControl({ value: data.BUYERTYPEID, disabled: false }, []),
      influenceid: new FormControl({ value: data.INFLUENCEID, disabled: false }, []),
      contactid: new FormControl({ value: data.CONTACTID, disabled: false }, [Validators.required]),
    })

    this.NameContact = data.CONTACT

    this.PopupNewAssociatePeopple = true

    setTimeout(() => {
      this.newRequestBySelect.placeholder = data.CONTACT

    }, 500);
  }

  closeModalEmail() {
    this.emailPopup = false
  }

  showSendEmail: boolean = false;

  getDataUSerConnected() {
    const idUserConnected = localStorage.getItem('clienuser');
    this.MapInformationService.SaveInfoSites({ method: "Get_EMPLOYEE_EMAIL_CONNECTIONS", employeeid: idUserConnected })
      .subscribe(infoEmpleado => {
        console.log(infoEmpleado);
        if (infoEmpleado.length > 0) {
            this.showSendEmail = true;
          } else {
            this.showSendEmail = false;
          }
      })
  }

  redirectToMyInformation() {
    this.router.navigate(['/myInformation']);
  }

  CUSTOMERREQPRICEID: any;

  getSalesLeads() {
    this.MapInformationService.SaveInfoSites({ method: "Get_SalesLead_ByID", id: this.idParent })
      .subscribe(resp => {
        console.log(resp)

        if (resp.length > 0) {
          if (resp[0].CUSTOMERREQPRICEID) {
            this.CUSTOMERREQPRICEID = resp[0].CUSTOMERREQPRICEID
          }
        }

        console.log('CUSTOMERREQPRICEID', this.CUSTOMERREQPRICEID)
      })
  }

  convertdate(str) {
    var date = new Date(str);
    var day: any = date.getDate();
    var month: any = date.getMonth() + 1;
    return [date.getFullYear(), month, day].join("-") + " 00:00:00";
  }

  substrultimatechar(element) {
    return element.substr(0, element.length - 2);
  }

  goToProject(projectId) {
    this.router.navigate(['/salesProject/editSales/', projectId]);
  }
}